import { Injectable } from '@angular/core';
// Libraries
import * as moment from 'moment';
// Afidium
import { DateService } from 'libraries/date/date.service';
import { Yii } from 'libraries/interfaces/Yii';
import { ErrorTracingService, TraceSeverity } from "libraries/service/error-tracing/error-tracing.service";

@Injectable()
export class DateDifferenceService {
    constructor(
        private dateService: DateService,
        private readonly errorTracingService: ErrorTracingService,
    ) {}

    public getDiffText(beginDate: string, endDate: string): string {
        if (!beginDate && !endDate) {
            this.errorTracingService.captureMessage( "DateDifferenceService: Il manque l'une des dates", TraceSeverity.Error);
            return null;
        }else{
            const begin: moment.Moment = moment(new Date(beginDate));
            const end: moment.Moment = moment(new Date(endDate));
            const hours: number = begin.diff(end, 'hours');
            const minutes: number = begin.diff(end, 'minutes');

            if (hours > 24) {
                const timeString: string = hours > 1 ? Yii.t('wui-shared-js', 'jours') : Yii.t('wui-shared-js', 'jour');
                return `${Math.floor(hours / 24)} ${timeString}`;
            }
            return this.dateService.getDuration(minutes);
        }
    }
}